import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const AutomationAcceptTranslationInputI18n = {
  configuration: { namespace: I18nNamespace.AUTOMATION_ACCEPT_TRANSLATION_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.automaticallyAcceptTranslation,
  },
};
